import { useCallback } from 'react';

import { useAppDispatch } from 'src/store';
import { getPaginationRequest } from 'src/ts/interfaces';
import { rentVerificationGetAllThunk } from '../services';

const useGetRentVerification = () => {
  const dispatch = useAppDispatch();

  const onGetRentVerifications = useCallback(
    (filters: getPaginationRequest) => dispatch(rentVerificationGetAllThunk(filters)),
    [dispatch]
  );

  return {
    onGetRentVerifications
  };
};

export default useGetRentVerification;
